export var addPerformanceMeasures = function addPerformanceMeasures(start, measures) {
  try {
    measures.sort(function (a, b) {
      return b.revision.localeCompare(a.revision);
    }).slice(0, 2).forEach(function (entry) {
      var _entry$vcDetails;
      if (((_entry$vcDetails = entry.vcDetails) === null || _entry$vcDetails === void 0 || (_entry$vcDetails = _entry$vcDetails['90']) === null || _entry$vcDetails === void 0 ? void 0 : _entry$vcDetails.t) !== undefined) {
        var _entry$vcDetails2;
        performance.mark("VC90 (".concat(entry.revision, ")"), {
          startTime: start + ((_entry$vcDetails2 = entry.vcDetails) === null || _entry$vcDetails2 === void 0 || (_entry$vcDetails2 = _entry$vcDetails2['90']) === null || _entry$vcDetails2 === void 0 ? void 0 : _entry$vcDetails2.t),
          detail: {
            devtools: {
              dataType: 'marker'
            }
          }
        });
      }
    });
    measures.forEach(function (entry) {
      var _entry$vcDetails3;
      if (!entry || !entry.vcDetails) {
        return;
      }
      var VCParts = Object.keys(entry.vcDetails);
      performance.measure("VC90 (".concat(entry.revision, ")"), {
        start: start,
        duration: (_entry$vcDetails3 = entry.vcDetails) === null || _entry$vcDetails3 === void 0 || (_entry$vcDetails3 = _entry$vcDetails3['90']) === null || _entry$vcDetails3 === void 0 ? void 0 : _entry$vcDetails3.t,
        detail: {
          devtools: {
            track: "main metrics",
            trackGroup: '🛸 reactUFO metrics',
            color: 'tertiary'
          }
        }
      });
      VCParts.forEach(function (key) {
        var _entry$vcDetails4;
        var duration = (_entry$vcDetails4 = entry.vcDetails) === null || _entry$vcDetails4 === void 0 ? void 0 : _entry$vcDetails4[key].t;
        if (typeof duration !== 'number') {
          return;
        }
        performance.measure("VC".concat(key), {
          start: start,
          duration: duration,
          detail: {
            devtools: {
              track: "VC ".concat(entry.revision),
              trackGroup: '🛸 reactUFO metrics',
              color: key === '90' ? 'tertiary' : 'primary-light'
            }
          }
        });
      });
    });
  } catch (error) {}
};